import { useUploads } from '../sync/uploadQueue';
import { useBoard, useBoardMeta, useItemsVersion, usePane, useSyncState } from './context';

const LABELS = {
  connecting: 'connecting',
  synced: 'synced',
  syncing: 'syncing',
  offline: 'offline',
  error: 'sync error',
} as const;

export function StatusBar() {
  const board = useBoard();
  const meta = useBoardMeta();
  useItemsVersion();
  const selected = usePane((s) => s.selection.size);
  const sync = useSyncState();
  const uploads = useUploads((s) => s.pending);

  return (
    <div className="statusbar">
      <span className="statusbar-title">{meta.title || board.boardId}</span>
      <span>{board.index.size} items</span>
      {selected > 0 && <span>{selected} selected</span>}
      {uploads > 0 && <span>{uploads} uploading</span>}
      {board.remote && (
        <span className={`sync sync-${sync.status}`} title={sync.error ?? undefined}>
          <i />
          {sync.role === 'viewer' ? 'view only' : LABELS[sync.status]}
          {sync.status === 'error' && sync.error ? `: ${sync.error}` : ''}
        </span>
      )}
      {!board.remote && <span className="sync sync-local">local only</span>}
    </div>
  );
}
